import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container } from 'react-bootstrap'

import Breadcrumbs from './../block/Breadcrumbs'
import AkciiSlyder from './../block/AkciiSlyder'
import TestimonialsSection from './../block/TestimonialsSection'
import FAQSection from './../block/FAQSection'

import styles from './../style/Page.module.scss'

export default class Main extends Component {

  render() {

    const { data, ajax_data, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <section className={styles.section + ` pb-0`}>
          <Container className={styles.container}>
            <h1>Акции</h1>
          </Container>
        </section>
        <AkciiSlyder
          page_data={data?.page_data || {}}
          slydes={ajax_data?.akciislyder || []}
          hidetitle={true}
        />
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}